// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .ShortsVideo {
    margin-top: 15vh;
    margin-left: 30vw;
    margin-bottom: 6vh;
    position: relative;
    z-index: 1;
} */

.shortsVideoContainer {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-left: 5vw;
    height: 84vh;
    overflow-y: auto;
    scroll-behavior: smooth;
    scrollbar-width: none;
    /* Hide scrollbar for Firefox */
    -ms-overflow-style: none;
    /* Hide scrollbar for IE and Edge */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.shortsVideoContainer::-webkit-scrollbar {
    display: none;
}

.shortsVideoContainer2 {
    height: 84vh;
    width: 35vw;
    scroll-snap-align: start;
    flex-shrink: 0;
}

.shortsVideoContainer2.active {
    display: block;
}

.shortsVideoContainer2.hidden {
    opacity: 0;
    visibility: hidden;
}

.videoContainer {
    height: 100%;
    width: 100%;
    border-radius: 10px;
    border: 1.5px solid rgba(255, 255, 255, 0.07);
    background-color: #070F0F;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    position: relative;
    z-index: 1;
}

.videoElement {
    height: 100%;
    width: 100%;
    border-radius: 10px;
    object-fit: cover;
}

.shortsVideoDetailsContainer {
    position: absolute;
    left: 4%;
    bottom: 2%;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 2px;
    width: 85%;
    /* max-height: 32%; */
    overflow: hidden;
}

.shortsVideoProfileDetails {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1vh;
}

.shortsVideoProfilePic {
    height: 35px;
    width: 35px;
    object-fit: contain;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 14px;
    font-family: 'Arial, sans-serif';
}

.shortsVideoProfileName {
    font-family: "Satoshi", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 14.52px;
    text-transform: capitalize;
    color: #fff;
}

.shortsVideoDescriptionContainer {
    margin-left: 2.3vw;
    /* max-height: 100px; */
    width: 90%;
}

.shortsVideoDescriptionText {
    font-family: "Satoshi", sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 18px;
    text-transform: capitalize;
    color: #fff;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding-bottom: 1vh;
}

.moreLessText {
    font-family: "Satoshi", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-transform: capitalize;
    color: #fff;
    cursor: pointer;
    color: #5AAF9A;
}

.actionContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2vh;
    position: absolute;
    left: 92%;
    top: 70%;
    z-index: 10;
}

.actionItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    cursor: pointer;
}

.actionItem {
    transition: transform 0.2s ease;
}

.actionItem:hover {
    transform: scale(1.1);
}

.countText {
    font-family: "Satoshi", sans-serif;
    font-size: 14px;
    color: #fff;
    transition: color 0.3s ease;
}

.commentDialogContainer {
    position: fixed;
    left: 63%;
    top: 22%;
    display: flex;
    flex-direction: column;
    width: 20vw;
    min-width: 320px;
    max-width: 380px;
    height: 56vh;
    min-height: 440px;
    background: linear-gradient(165deg, rgba(17, 32, 32, 0.94) 0%, rgba(9, 18, 18, 0.97) 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 18px;
    box-sizing: border-box;
    padding: 0;
    z-index: 10000;
    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.65), 0 0 0 1px rgba(90, 175, 154, 0.18);
    overflow: hidden;
    animation: commentDialogFadeIn 0.22s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes commentDialogFadeIn {
    from {
        opacity: 0;
        transform: translateY(8px) scale(0.98);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@media (max-width: 1024px) {
    .commentDialogContainer {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 88vw;
        max-width: 360px;
        height: 60vh;
    }
}

/* Header */
.commentHeaderContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.02);
}

.commentHeaderLeft {
    display: flex;
    align-items: center;
    gap: 8px;
}

.commentHeaderText {
    font-family: "Satoshi", -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 15px;
    color: #ffffff;
    font-weight: 700;
    letter-spacing: -0.2px;
}

.commentHeaderBadge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border-radius: 10px;
    background: rgba(90, 175, 154, 0.16);
    color: #5AAF9A;
    font-family: "Satoshi", sans-serif;
    font-size: 11px;
    font-weight: 700;
}

.commentCloseBtn {
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    transition: background 0.2s ease, transform 0.15s ease, color 0.2s ease;
    color: rgba(255, 255, 255, 0.6);
    padding: 0;
}

.commentCloseBtn:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    transform: scale(1.08);
}

/* Scrollable Content */
.commentContentContainer {
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1 1;
    overflow-y: auto;
    padding: 16px 18px;
    scrollbar-width: thin;
    scrollbar-color: rgba(90, 175, 154, 0.3) transparent;
}

.commentContentContainer::-webkit-scrollbar {
    width: 5px;
}

.commentContentContainer::-webkit-scrollbar-track {
    background: transparent;
}

.commentContentContainer::-webkit-scrollbar-thumb {
    background: rgba(90, 175, 154, 0.25);
    border-radius: 10px;
    -webkit-transition: background 0.2s ease;
    transition: background 0.2s ease;
}

.commentContentContainer::-webkit-scrollbar-thumb:hover {
    background: rgba(90, 175, 154, 0.5);
}

/* Empty State */
.noCommentContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto 0;
    padding: 24px 12px;
    text-align: center;
}

.noCommentIconWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(90, 175, 154, 0.2) 0%, rgba(90, 175, 154, 0.04) 70%);
    border: 1px solid rgba(90, 175, 154, 0.25);
    margin-bottom: 12px;
}

.noCommentsTitle {
    font-family: "Satoshi", sans-serif;
    font-size: 14px;
    color: #ffffff;
    font-weight: 600;
    margin-bottom: 4px;
}

.noCommentsSubtitle {
    font-family: "Satoshi", sans-serif;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;
}

/* Comment Item */
.videoCommentItem {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.05);
    position: relative;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.videoCommentItem:hover {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.08);
}

.videoCommentItemProfilePic {
    height: 32px;
    width: 32px;
    min-width: 32px;
    object-fit: cover;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.15);
}

.videoCommentItemTextContainer {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1;
    min-width: 0;
}

.videoCommentItemHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-right: 18px;
}

.videoCommentItemUserName {
    font-family: "Satoshi", sans-serif;
    font-size: 13px;
    color: #ffffff;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.videoCommentItemTime {
    font-family: "Satoshi", sans-serif;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.45);
    flex-shrink: 0;
}

.videoCommentItemCommentText {
    font-family: "Satoshi", sans-serif;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.4;
    word-break: break-word;
    padding-right: 4px;
}

.commentVotePill {
    display: inline-flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 1px 4px;
    gap: 2px;
}

.commentVoteCount {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    min-width: 14px;
    text-align: center;
    font-family: "Satoshi", sans-serif;
}

.deleteCommentIcon {
    position: absolute;
    top: 10px;
    right: 10px;
    transition: color 0.2s ease, transform 0.15s ease;
}

.deleteCommentIcon:hover {
    transform: scale(1.1);
}

/* Input Container */
.commentShortsInputContainer {
    width: 100%;
    padding: 12px 14px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(12, 24, 24, 0.9);
    box-sizing: border-box;
}

.commentInputWrapper {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 22px;
    padding: 3px 5px 3px 14px;
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.commentInputWrapper:focus-within {
    border-color: #5AAF9A;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0 0 0 2px rgba(90, 175, 154, 0.2);
}

.commentInput {
    flex: 1 1;
    background: transparent;
    border: none;
    outline: none;
    color: #ffffff;
    font-family: "Satoshi", -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 13px;
    line-height: 20px;
    padding: 6px 0;
    min-width: 0;
}

.commentInput::placeholder {
    color: rgba(255, 255, 255, 0.4);
    font-size: 13px;
}

.shortsCommentSendBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: none;
    background: transparent;
    color: rgba(255, 255, 255, 0.25);
    cursor: default;
    transition: background 0.2s ease, color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
    padding: 0;
    flex-shrink: 0;
}

.shortsCommentSendBtn.active {
    background: #5AAF9A;
    color: #0d1a19;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(90, 175, 154, 0.35);
}

.shortsCommentSendBtn.active:hover {
    background: #6ec4af;
    transform: scale(1.08);
}

.infoContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 1vh;
    position: absolute;
    top: 2%;
    right: 2%;
}

.volumeControlContainer {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s ease;
    z-index: 5;
    padding: 1.2vh;
}

.volumeControlContainer:hover {
    background-color: rgba(0, 0, 0, 0.7);
}

.shorts-blur {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
}

.shortsVideoProfileNameContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1vh;
}

.shortsVoteDescriptionContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 2.5vh;
}

@media (max-width: 1640px) {
    .shortsVideoProfilePic {
        height: 33px;
        width: 33px;
        font-size: 13px;
    }

    .shortsVideoProfileName {
        font-size: 15px;
        line-height: 13.52px;
    }

    .videoCommentItemTime {
        font-size: 11px;
    }

    .shortsVideoDescriptionText {
        font-size: 14px;
        line-height: 17px;
    }

    /* .shortsVideoDescriptionContainer {
        max-height: 90px;
    } */
    .actionContainer {
        gap: 1.8vh;
        top: 68%;
    }

    .countText {
        font-size: 13px;
    }

    .commentHeaderText {
        font-size: 15px;
    }

    .noCommentsText {
        font-size: 13px;
    }

    .videoCommentItemProfilePic {
        height: 33px;
        width: 33px;
    }

    .videoCommentItemTime {
        font-size: 11px;
    }

    .videoCommentItemUserName {
        font-size: 14px;
    }

    .videoCommentItemCommentText {
        font-size: 13px;
    }

    .moreLessText {
        font-size: 11px;
        line-height: 12px;
    }
}

@media (max-width: 1440px) {
    .shortsVideoProfilePic {
        height: 30px;
        width: 30px;
        font-size: 12px;
    }

    .shortsVideoProfileName {
        font-size: 14px;
        line-height: 12.52px;
    }

    .videoCommentItemTime {
        font-size: 10px;
    }

    .shortsVideoDescriptionText {
        font-size: 13px;
        line-height: 16px;
    }

    /* .shortsVideoDescriptionContainer {
        max-height: 85px;
    } */
    .actionContainer {
        gap: 1.5vh;
        top: 67%;
    }

    .countText {
        font-size: 12px;
    }

    .commentHeaderText {
        font-size: 14px;
    }

    .noCommentsText {
        font-size: 12px;
    }

    .videoCommentItemProfilePic {
        height: 30px;
        width: 30px;
    }

    .videoCommentItemTime {
        font-size: 10px;
    }

    .videoCommentItemUserName {
        font-size: 13px;
    }

    .videoCommentItemCommentText {
        font-size: 12px;
    }

    .commentInput {
        border-radius: 8px;
        font-size: 12px;
    }

    .moreLessText {
        font-size: 10px;
        line-height: 11px;
    }
}

@media (max-width: 1280px) {
    .shortsVideoProfilePic {
        height: 28px;
        width: 28px;
        font-size: 11px;
    }

    .shortsVideoProfileName {
        font-size: 13px;
        line-height: 11.52px;
    }

    .videoCommentItemTime {
        font-size: 9px;
    }

    .shortsVideoDescriptionText {
        font-size: 12px;
        line-height: 15px;
    }

    /* .shortsVideoDescriptionContainer {
        max-height: 80px;
    } */
    .actionContainer {
        gap: 1.2vh;
        top: 66%;
    }

    .countText {
        font-size: 11px;
    }

    .commentHeaderText {
        font-size: 12px;
    }

    .noCommentsText {
        font-size: 10px;
    }

    .videoCommentItemProfilePic {
        height: 28px;
        width: 28px;
    }

    .videoCommentItemUserName {
        font-size: 12px;
    }

    .videoCommentItemCommentText {
        font-size: 11px;
    }

    .videoCommentItemTime {
        font-size: 8px;
    }

    /* .shortsCommentSendIcon {
        top: 10px;
        right: 7px;
    } */
    .commentInput {
        font-size: 11px;
    }

    .moreLessText {
        font-size: 9px;
        line-height: 10px;
    }
}

@media (max-width: 1024px) {
    .shortsVideoProfilePic {
        height: 25px;
        width: 25px;
        font-size: 10px;
    }

    .shortsVideoProfileName {
        font-size: 12px;
        line-height: 10.52px;
    }

    .videoCommentItemTime {
        font-size: 8px;
    }

    .shortsVideoDescriptionText {
        font-size: 11px;
        line-height: 14px;
    }

    /* .shortsVideoDescriptionContainer {
        max-height: 75px;
    } */
    .actionContainer {
        gap: 1vh;
        top: 65%;
    }

    .countText {
        font-size: 10px;
    }

    .commentHeaderText {
        font-size: 10px;
    }

    .noCommentsText {
        font-size: 9px;
    }

    .videoCommentItemProfilePic {
        height: 25px;
        width: 25px;
    }

    .videoCommentItemUserName {
        font-size: 10px;
    }

    .videoCommentItemCommentText {
        font-size: 10px;
    }

    .videoCommentItemTime {
        font-size: 6px;
    }

    .commentInput {
        border-radius: 6px;
    }

    .shortsCommentSendIcon {
        /* top: 25%; */
        right: 5%;
    }

    .commentInput {
        font-size: 10px;
    }

    .moreLessText {
        font-size: 8px;
        line-height: 9px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/ShortsVideo/ShortsVideo.css"],"names":[],"mappings":"AAAA;;;;;;GAMG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,+BAA+B;IAC/B,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA,gDAAgD;AAChD;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,6CAA6C;IAC7C,yBAAyB;IACzB,0BAA0B;IAC1B,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,0FAA0F;IAC1F,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,cAAc;IACd,+EAA+E;IAC/E,gBAAgB;IAChB,kEAAkE;AACtE;;AAEA;IACI;QACI,UAAU;QACV,sCAAsC;IAC1C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,SAAS;QACT,QAAQ;QACR,gCAAgC;QAChC,WAAW;QACX,gBAAgB;QAChB,YAAY;IAChB;AACJ;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kDAAkD;IAClD,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qEAAqE;IACrE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,oCAAoC;IACpC,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uEAAuE;IACvE,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,oDAAoD;AACxD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,wCAAgC;IAAhC,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6FAA6F;IAC7F,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,kBAAkB;IAClB,+CAA+C;IAC/C,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8EAA8E;AAClF;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,qEAAqE;IACrE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;IACf,6FAA6F;IAC7F,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;IACtC,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;OAEG;IACH;QACI,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;OAEG;IACH;QACI,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;OAEG;IACH;QACI,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;;;OAGG;IACH;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;OAEG;IACH;QACI,QAAQ;QACR,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ","sourcesContent":["/* .ShortsVideo {\n    margin-top: 15vh;\n    margin-left: 30vw;\n    margin-bottom: 6vh;\n    position: relative;\n    z-index: 1;\n} */\n\n.shortsVideoContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    margin-left: 5vw;\n    height: 84vh;\n    overflow-y: auto;\n    scroll-behavior: smooth;\n    scrollbar-width: none;\n    /* Hide scrollbar for Firefox */\n    -ms-overflow-style: none;\n    /* Hide scrollbar for IE and Edge */\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.shortsVideoContainer::-webkit-scrollbar {\n    display: none;\n}\n\n.shortsVideoContainer2 {\n    height: 84vh;\n    width: 35vw;\n    scroll-snap-align: start;\n    flex-shrink: 0;\n}\n\n.shortsVideoContainer2.active {\n    display: block;\n}\n\n.shortsVideoContainer2.hidden {\n    opacity: 0;\n    visibility: hidden;\n}\n\n.videoContainer {\n    height: 100%;\n    width: 100%;\n    border-radius: 10px;\n    border: 1.5px solid rgba(255, 255, 255, 0.07);\n    background-color: #070F0F;\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    position: relative;\n    z-index: 1;\n}\n\n.videoElement {\n    height: 100%;\n    width: 100%;\n    border-radius: 10px;\n    object-fit: cover;\n}\n\n.shortsVideoDetailsContainer {\n    position: absolute;\n    left: 4%;\n    bottom: 2%;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 2px;\n    width: 85%;\n    /* max-height: 32%; */\n    overflow: hidden;\n}\n\n.shortsVideoProfileDetails {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1vh;\n}\n\n.shortsVideoProfilePic {\n    height: 35px;\n    width: 35px;\n    object-fit: contain;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-weight: bold;\n    font-size: 14px;\n    font-family: 'Arial, sans-serif';\n}\n\n.shortsVideoProfileName {\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 14.52px;\n    text-transform: capitalize;\n    color: #fff;\n}\n\n.shortsVideoDescriptionContainer {\n    margin-left: 2.3vw;\n    /* max-height: 100px; */\n    width: 90%;\n}\n\n.shortsVideoDescriptionText {\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 18px;\n    text-transform: capitalize;\n    color: #fff;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    padding-bottom: 1vh;\n}\n\n.moreLessText {\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: capitalize;\n    color: #fff;\n    cursor: pointer;\n    color: #5AAF9A;\n}\n\n.actionContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 2vh;\n    position: absolute;\n    left: 92%;\n    top: 70%;\n    z-index: 10;\n}\n\n.actionItem {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n}\n\n.actionItem {\n    transition: transform 0.2s ease;\n}\n\n.actionItem:hover {\n    transform: scale(1.1);\n}\n\n.countText {\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 14px;\n    color: #fff;\n    transition: color 0.3s ease;\n}\n\n.commentDialogContainer {\n    position: fixed;\n    left: 63%;\n    top: 22%;\n    display: flex;\n    flex-direction: column;\n    width: 20vw;\n    min-width: 320px;\n    max-width: 380px;\n    height: 56vh;\n    min-height: 440px;\n    background: linear-gradient(165deg, rgba(17, 32, 32, 0.94) 0%, rgba(9, 18, 18, 0.97) 100%);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 18px;\n    box-sizing: border-box;\n    padding: 0;\n    z-index: 10000;\n    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.65), 0 0 0 1px rgba(90, 175, 154, 0.18);\n    overflow: hidden;\n    animation: commentDialogFadeIn 0.22s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes commentDialogFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(8px) scale(0.98);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n@media (max-width: 1024px) {\n    .commentDialogContainer {\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: 88vw;\n        max-width: 360px;\n        height: 60vh;\n    }\n}\n\n/* Header */\n.commentHeaderContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 18px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(255, 255, 255, 0.02);\n}\n\n.commentHeaderLeft {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.commentHeaderText {\n    font-family: \"Satoshi\", -apple-system, BlinkMacSystemFont, sans-serif;\n    font-size: 15px;\n    color: #ffffff;\n    font-weight: 700;\n    letter-spacing: -0.2px;\n}\n\n.commentHeaderBadge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 20px;\n    height: 20px;\n    padding: 0 6px;\n    border-radius: 10px;\n    background: rgba(90, 175, 154, 0.16);\n    color: #5AAF9A;\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.commentCloseBtn {\n    background: transparent;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    transition: background 0.2s ease, transform 0.15s ease, color 0.2s ease;\n    color: rgba(255, 255, 255, 0.6);\n    padding: 0;\n}\n\n.commentCloseBtn:hover {\n    background: rgba(255, 255, 255, 0.1);\n    color: #ffffff;\n    transform: scale(1.08);\n}\n\n/* Scrollable Content */\n.commentContentContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 18px;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(90, 175, 154, 0.3) transparent;\n}\n\n.commentContentContainer::-webkit-scrollbar {\n    width: 5px;\n}\n\n.commentContentContainer::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.commentContentContainer::-webkit-scrollbar-thumb {\n    background: rgba(90, 175, 154, 0.25);\n    border-radius: 10px;\n    transition: background 0.2s ease;\n}\n\n.commentContentContainer::-webkit-scrollbar-thumb:hover {\n    background: rgba(90, 175, 154, 0.5);\n}\n\n/* Empty State */\n.noCommentContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin: auto 0;\n    padding: 24px 12px;\n    text-align: center;\n}\n\n.noCommentIconWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(90, 175, 154, 0.2) 0%, rgba(90, 175, 154, 0.04) 70%);\n    border: 1px solid rgba(90, 175, 154, 0.25);\n    margin-bottom: 12px;\n}\n\n.noCommentsTitle {\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 14px;\n    color: #ffffff;\n    font-weight: 600;\n    margin-bottom: 4px;\n}\n\n.noCommentsSubtitle {\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.5);\n    font-weight: 400;\n}\n\n/* Comment Item */\n.videoCommentItem {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 10px;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    position: relative;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.videoCommentItem:hover {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(255, 255, 255, 0.08);\n}\n\n.videoCommentItemProfilePic {\n    height: 32px;\n    width: 32px;\n    min-width: 32px;\n    object-fit: cover;\n    border-radius: 50%;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.videoCommentItemTextContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n    min-width: 0;\n}\n\n.videoCommentItemHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding-right: 18px;\n}\n\n.videoCommentItemUserName {\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 13px;\n    color: #ffffff;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.videoCommentItemTime {\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.45);\n    flex-shrink: 0;\n}\n\n.videoCommentItemCommentText {\n    font-family: \"Satoshi\", sans-serif;\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.9);\n    line-height: 1.4;\n    word-break: break-word;\n    padding-right: 4px;\n}\n\n.commentVotePill {\n    display: inline-flex;\n    align-items: center;\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n    padding: 1px 4px;\n    gap: 2px;\n}\n\n.commentVoteCount {\n    font-size: 12px;\n    font-weight: 600;\n    color: #ffffff;\n    min-width: 14px;\n    text-align: center;\n    font-family: \"Satoshi\", sans-serif;\n}\n\n.deleteCommentIcon {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    transition: color 0.2s ease, transform 0.15s ease;\n}\n\n.deleteCommentIcon:hover {\n    transform: scale(1.1);\n}\n\n/* Input Container */\n.commentShortsInputContainer {\n    width: 100%;\n    padding: 12px 14px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(12, 24, 24, 0.9);\n    box-sizing: border-box;\n}\n\n.commentInputWrapper {\n    display: flex;\n    align-items: center;\n    position: relative;\n    width: 100%;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 22px;\n    padding: 3px 5px 3px 14px;\n    box-sizing: border-box;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.commentInputWrapper:focus-within {\n    border-color: #5AAF9A;\n    background: rgba(255, 255, 255, 0.08);\n    box-shadow: 0 0 0 2px rgba(90, 175, 154, 0.2);\n}\n\n.commentInput {\n    flex: 1;\n    background: transparent;\n    border: none;\n    outline: none;\n    color: #ffffff;\n    font-family: \"Satoshi\", -apple-system, BlinkMacSystemFont, sans-serif;\n    font-size: 13px;\n    line-height: 20px;\n    padding: 6px 0;\n    min-width: 0;\n}\n\n.commentInput::placeholder {\n    color: rgba(255, 255, 255, 0.4);\n    font-size: 13px;\n}\n\n.shortsCommentSendBtn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    border: none;\n    background: transparent;\n    color: rgba(255, 255, 255, 0.25);\n    cursor: default;\n    transition: background 0.2s ease, color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;\n    padding: 0;\n    flex-shrink: 0;\n}\n\n.shortsCommentSendBtn.active {\n    background: #5AAF9A;\n    color: #0d1a19;\n    cursor: pointer;\n    box-shadow: 0 2px 8px rgba(90, 175, 154, 0.35);\n}\n\n.shortsCommentSendBtn.active:hover {\n    background: #6ec4af;\n    transform: scale(1.08);\n}\n\n.infoContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 1vh;\n    position: absolute;\n    top: 2%;\n    right: 2%;\n}\n\n.volumeControlContainer {\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    z-index: 5;\n    padding: 1.2vh;\n}\n\n.volumeControlContainer:hover {\n    background-color: rgba(0, 0, 0, 0.7);\n}\n\n.shorts-blur {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 9999;\n    background: rgba(0, 0, 0, 0.2);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n}\n\n.shortsVideoProfileNameContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1vh;\n}\n\n.shortsVoteDescriptionContainer {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-top: 2.5vh;\n}\n\n@media (max-width: 1640px) {\n    .shortsVideoProfilePic {\n        height: 33px;\n        width: 33px;\n        font-size: 13px;\n    }\n\n    .shortsVideoProfileName {\n        font-size: 15px;\n        line-height: 13.52px;\n    }\n\n    .videoCommentItemTime {\n        font-size: 11px;\n    }\n\n    .shortsVideoDescriptionText {\n        font-size: 14px;\n        line-height: 17px;\n    }\n\n    /* .shortsVideoDescriptionContainer {\n        max-height: 90px;\n    } */\n    .actionContainer {\n        gap: 1.8vh;\n        top: 68%;\n    }\n\n    .countText {\n        font-size: 13px;\n    }\n\n    .commentHeaderText {\n        font-size: 15px;\n    }\n\n    .noCommentsText {\n        font-size: 13px;\n    }\n\n    .videoCommentItemProfilePic {\n        height: 33px;\n        width: 33px;\n    }\n\n    .videoCommentItemTime {\n        font-size: 11px;\n    }\n\n    .videoCommentItemUserName {\n        font-size: 14px;\n    }\n\n    .videoCommentItemCommentText {\n        font-size: 13px;\n    }\n\n    .moreLessText {\n        font-size: 11px;\n        line-height: 12px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .shortsVideoProfilePic {\n        height: 30px;\n        width: 30px;\n        font-size: 12px;\n    }\n\n    .shortsVideoProfileName {\n        font-size: 14px;\n        line-height: 12.52px;\n    }\n\n    .videoCommentItemTime {\n        font-size: 10px;\n    }\n\n    .shortsVideoDescriptionText {\n        font-size: 13px;\n        line-height: 16px;\n    }\n\n    /* .shortsVideoDescriptionContainer {\n        max-height: 85px;\n    } */\n    .actionContainer {\n        gap: 1.5vh;\n        top: 67%;\n    }\n\n    .countText {\n        font-size: 12px;\n    }\n\n    .commentHeaderText {\n        font-size: 14px;\n    }\n\n    .noCommentsText {\n        font-size: 12px;\n    }\n\n    .videoCommentItemProfilePic {\n        height: 30px;\n        width: 30px;\n    }\n\n    .videoCommentItemTime {\n        font-size: 10px;\n    }\n\n    .videoCommentItemUserName {\n        font-size: 13px;\n    }\n\n    .videoCommentItemCommentText {\n        font-size: 12px;\n    }\n\n    .commentInput {\n        border-radius: 8px;\n        font-size: 12px;\n    }\n\n    .moreLessText {\n        font-size: 10px;\n        line-height: 11px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .shortsVideoProfilePic {\n        height: 28px;\n        width: 28px;\n        font-size: 11px;\n    }\n\n    .shortsVideoProfileName {\n        font-size: 13px;\n        line-height: 11.52px;\n    }\n\n    .videoCommentItemTime {\n        font-size: 9px;\n    }\n\n    .shortsVideoDescriptionText {\n        font-size: 12px;\n        line-height: 15px;\n    }\n\n    /* .shortsVideoDescriptionContainer {\n        max-height: 80px;\n    } */\n    .actionContainer {\n        gap: 1.2vh;\n        top: 66%;\n    }\n\n    .countText {\n        font-size: 11px;\n    }\n\n    .commentHeaderText {\n        font-size: 12px;\n    }\n\n    .noCommentsText {\n        font-size: 10px;\n    }\n\n    .videoCommentItemProfilePic {\n        height: 28px;\n        width: 28px;\n    }\n\n    .videoCommentItemUserName {\n        font-size: 12px;\n    }\n\n    .videoCommentItemCommentText {\n        font-size: 11px;\n    }\n\n    .videoCommentItemTime {\n        font-size: 8px;\n    }\n\n    /* .shortsCommentSendIcon {\n        top: 10px;\n        right: 7px;\n    } */\n    .commentInput {\n        font-size: 11px;\n    }\n\n    .moreLessText {\n        font-size: 9px;\n        line-height: 10px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .shortsVideoProfilePic {\n        height: 25px;\n        width: 25px;\n        font-size: 10px;\n    }\n\n    .shortsVideoProfileName {\n        font-size: 12px;\n        line-height: 10.52px;\n    }\n\n    .videoCommentItemTime {\n        font-size: 8px;\n    }\n\n    .shortsVideoDescriptionText {\n        font-size: 11px;\n        line-height: 14px;\n    }\n\n    /* .shortsVideoDescriptionContainer {\n        max-height: 75px;\n    } */\n    .actionContainer {\n        gap: 1vh;\n        top: 65%;\n    }\n\n    .countText {\n        font-size: 10px;\n    }\n\n    .commentHeaderText {\n        font-size: 10px;\n    }\n\n    .noCommentsText {\n        font-size: 9px;\n    }\n\n    .videoCommentItemProfilePic {\n        height: 25px;\n        width: 25px;\n    }\n\n    .videoCommentItemUserName {\n        font-size: 10px;\n    }\n\n    .videoCommentItemCommentText {\n        font-size: 10px;\n    }\n\n    .videoCommentItemTime {\n        font-size: 6px;\n    }\n\n    .commentInput {\n        border-radius: 6px;\n    }\n\n    .shortsCommentSendIcon {\n        /* top: 25%; */\n        right: 5%;\n    }\n\n    .commentInput {\n        font-size: 10px;\n    }\n\n    .moreLessText {\n        font-size: 8px;\n        line-height: 9px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
